import { render } from "./LargeHero.vue?vue&type=template&id=25abdbe4"
import script from "./LargeHero.vue?vue&type=script&lang=js"
export * from "./LargeHero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bdavies/Documents/git hub/undergraduate-degree-classification-calculator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__